(() => {
  let inFlight = false;       // prevent double-runs
  let redirected = false;     // ensure single redirect

  const baseCheckoutSelectors = [
    'button[name="checkout"]',
    'form[action="/cart"] [type="submit"]',
    'a[href="/checkout"]',
    '[data-cart-trigger="checkout"]',
    '[data-cart-trigger*="checkout"]',
    '[data-button*="checkout"]',
    '[data-action*="checkout"]',
    '[class*="checkout"]',
    '[id*="checkout"]'
  ];

  
  async function runCartAdjustments() {
    console.log('running cart adjustments');

    var productsToUpdate = [];
    var productsToAdd = [];
    
     fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { 
        var cartContents = data;
        var cartItems = data.items;

        if (cartItems.length > 0){
          cartItems.forEach((i) => {
            if (typeof i.properties['_options_addon_products'] != 'undefined'){
            var optionsGuid = i.properties['_options_group_id'];
            var optionsQty = i.quantity;
            var addOns = JSON.parse(i.properties['_options_addon_products']);
            addOns.forEach((a) => {
                var ext = cartItems.filter((x)=> x.variant_id == a.variantId && x.properties['_options_action'] == a.actionID && x.properties['_options_group_id']==optionsGuid);
                if(ext.length == 1){
                //check quantity
                if (ext[0].quantity != optionsQty){
                    
                    var p = {
                    key: ext[0].key,
                    quantity: optionsQty
                    }
                    productsToUpdate.push(p);
                }
                }
                if(ext.length == 0){
                var product = {
                    quantity: optionsQty,
                    id: a.variantId,
                    properties: {
                        "_options_group_id": optionsGuid,
                        "_options_hidden": 'true',
                        "_options_action": a.actionID
                    }
                }
                productsToAdd.push(product);
                }
            });
            }
        });

        return  updateCart(productsToUpdate, productsToAdd)

        }else{
          return { added: false, updated: false, skipped: true };
        }
    })
  }

function updateCart(productsToUpdate, productsToAdd){
  const addP = addProducts(productsToAdd);
  const updP = updateProducts(productsToUpdate);

  return Promise.allSettled([addP, updP]).then(results => {
    const summary = {
      added: (productsToAdd?.length || 0) > 0,
      updated: (productsToUpdate?.length || 0) > 0,
      results
    };
    return summary;
  });
}

function addProducts(productList){
    if (!productList || productList.length === 0) {
      return Promise.resolve({ skipped: true, op: 'add' });
    }

    let formData = {
        'items': productList
    };

    return fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
    }).then(r => {
      if (!r.ok) throw new Error('Add products failed: ' + r.status);
      return r.json();
    });
}

function updateProducts(updateList){
  if (!updateList || updateList.length === 0) {
    return Promise.resolve({ skipped: true, op: 'update' });
  }

  const formData = new FormData();
  updateList.forEach(u => {
    formData.append(`updates[${u.key}]`, String(u.quantity));
  });

  return fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
    method: 'POST',
    body: formData
  }).then(r => {
    if (!r.ok) throw new Error('Update products failed: ' + r.status);
    return r.json();
  });
}



  function proceedToCheckout(e) {
    if (redirected) return;
    redirected = true;

    window.location.assign('/checkout');

    // OR find element and initiate the click event
    //     const el = document.querySelector(checkoutClickSelector);
    //     if (el) {
    //       console.log('[Checkout Interceptor] Clicking detected checkout element:', el);
    //       el.click();
    //       return;
    //     }

  }

  async function handleBeginCheckout(e) {
    console.log('begin checkout');
    // Stop everything else from acting on this event
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    if (inFlight) return; // already handling this click/submit
    inFlight = true;

    try {
      await runCartAdjustments();
    } catch (err) {
      console.warn('Cart adjustment failed; continuing to checkout anyway.', err);
      
    } finally {
      proceedToCheckout(e);
      inFlight = false;
    }
  }

  var checkout = document.querySelector('.cart__checkout');
  if (checkout){
    checkout.addEventListener('click', (e)=>{
      handleBeginCheckout(e);
    }, { capture: true });
  }

  // Intercept submit on the cart form (covers Enter key and most buttons)
  // document.addEventListener('submit', (e) => {
  //   const form = e.target;
  //   if (form && form.matches('form[action="/cart"]')) {
  //     handleBeginCheckout(e);
  //   }
  // }, { capture: true });

  // // Intercept click on common checkout triggers
  // const extraSelectors = Array.isArray(window.additionalCheckoutSelectors)
  // ? window.additionalCheckoutSelectors
  // : [];

  // // Combine base and extras
  // const checkoutClickSelector = [...baseCheckoutSelectors, ...extraSelectors].join(',');

  // document.addEventListener('click', (e) => {
  //   const el = e.target.closest(checkoutClickSelector);
  //   if (el) {
  //     handleBeginCheckout(e);
  //   }
  // }, { capture: true });



// Optional: MutationObserver to “neutralize” rogue inline onclick handlers
//--------------------------------------------------------------------------
//   const mo = new MutationObserver((muts) => {
//     muts.forEach(m => {
//       m.addedNodes && m.addedNodes.forEach(n => {
//         if (!(n instanceof Element)) return;
//         n.querySelectorAll?.(checkoutClickSelector).forEach(btn => {
//           // Remove inline onclick to force our handler path
//           if (btn.hasAttribute('onclick')) btn.removeAttribute('onclick');
//         });
//       });
//     });
//   });
//   mo.observe(document.documentElement, { childList: true, subtree: true });


  // Optional: Global guard—if another script tries to redirect after you,
  //--------------------------------------------------------------------------
//   const originalAssign = window.location.assign.bind(window.location);
//   window.location.assign = function(url) {
//     if (redirected) return; // block additional redirects after ours
//     return originalAssign(url);
//   };
})();